'use client';

import { useGlobalUI } from 'contexts/GlobalUIContext';
import { AffiliateHero } from './AffiliateHero';
import { InviteGallery } from './InviteGallery';
import {
  AffiliateProducts,
  type AffiliateLandingData,
} from './AffiliateProducts';
import styles from './AffiliateLanding.module.css';

const HEADER_FLAGS = { headerCta: 'talkToExpert' } as const;

export const AffiliateLanding = ({
  affiliate,
}: {
  affiliate: AffiliateLandingData;
}) => {
  // The header's Buy now becomes "Talk to an expert" on the invite page.
  useGlobalUI(HEADER_FLAGS);

  return (
    <main className={styles.page}>
      <AffiliateHero name={affiliate.name} />
      <AffiliateProducts affiliate={affiliate} />
      <InviteGallery />
    </main>
  );
};
